var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"value":_vm.value,"options":_vm.options,"placeholder":_vm.placeholder,"loading":_vm.loading},on:{"input":_vm.onSelected}})}
var staticRenderFns = []

export { render, staticRenderFns }